/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.system').service('MacCaptionTemplatesService',
    function (this: JS5Object, _: JS5Object, MacCaptionTemplatesResourceFactory: JS5Object, PaginationService: JS5Object) {
        this.originalEditData = {};
        const handleGridDataQuery = (gridData, responseHeaders) => {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = gridData;
            this.currentPageSize = gridData.length;
        };

        this.getAllMacCaptionTemplates = (queryParams: JS5Object) => {
            return MacCaptionTemplatesResourceFactory.query(queryParams, handleGridDataQuery).$promise;
        };
        this.getMacCaptionTemplate = (macCaptionTemplateId: number) => {
            return MacCaptionTemplatesResourceFactory.get({id: macCaptionTemplateId}).$promise;
        };
        this.createMacCaptionTemplate = (macCaptionTemplate: JS5Object) => {
            return MacCaptionTemplatesResourceFactory.save(macCaptionTemplate).$promise;
        };
        this.cloneMacCaptionTemplate = (macCaptionTemplate: JS5Object) => {
            return MacCaptionTemplatesResourceFactory.clone({id: macCaptionTemplate.id}).$promise;
        };
        this.updateMacCaptionTemplate = (macCaptionTemplate: JS5Object) => {
            return MacCaptionTemplatesResourceFactory.update(macCaptionTemplate).$promise;
        };
        this.toggleMacCaptionTemplateHidden = (macCaptionTemplateId: number) => {
            return MacCaptionTemplatesResourceFactory.toggleArchive({id: macCaptionTemplateId}).$promise;
        };
    });
